"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const nxtp_utils_1 = require("@connext/nxtp-utils");
const nxtp_txservice_1 = require("@connext/nxtp-txservice");
const config_1 = require("./config");
const sdkUtils_1 = require("./sdkUtils");
const sdkBase_1 = require("./sdkBase");
const sdkRouter_1 = require("./sdkRouter");
const sdkPool_1 = require("./sdkPool");
const create = async (_config, _logger, _chainData) => {
    const { nxtpConfig, chainData } = await (0, config_1.getConfig)(_config, nxtp_txservice_1.contractDeployments, _chainData);
    const logger = _logger || new nxtp_utils_1.Logger({ name: "SDK", level: nxtpConfig.logLevel });
    const sdkBase = await sdkBase_1.SdkBase.create(nxtpConfig, logger, chainData);
    const sdkUtils = await sdkUtils_1.SdkUtils.create(nxtpConfig, logger, chainData);
    const sdkRouter = await sdkRouter_1.SdkRouter.create(nxtpConfig, logger, chainData);
    const sdkPool = await sdkPool_1.SdkPool.create(nxtpConfig, logger, chainData);
    const { requestContext, methodContext } = (0, nxtp_utils_1.createLoggingContext)("SDK create()");
    logger.info(`Initialized SDK with config: `, requestContext, methodContext, { nxtpConfig: nxtpConfig });
    return { sdkBase, sdkUtils, sdkRouter, sdkPool };
};
exports.create = create;
//# sourceMappingURL=sdk.js.map